/* FA2026 — dwa usprawnienia selektorów (bez ruszania sekcji; render = generyczna pętla):
   1) GREYOUT: w osiach Form/Breite wyszarza pigułki prowadzące do innego koloru/wysokości (szary+przekreślony).
   2) MODELL: oś „Modell" renderuje IDENTYCZNIE jak swatche related_colors — nadaje klasę product__color-variations-list
      i wstawia <img> (bez tekstu, podpis=tooltip). Dziedziczy natywny CSS motywu (zero własnych styli).
   Höhe/Farbe/Montageplatte nietknięte. Idempotentne. */
(function () {
  // ---- 1) GREYOUT (Form/Breite) ----
  try {
    function hc(s) { var m = (s || "").replace(/\?.*$/, "").replace(/\/$/, "").match(/-(\d+)mm-([a-z0-9-]+)$/); return m ? { h: m[1], c: m[2] } : null; }
    var cur = hc(location.pathname);
    // greyout TYLKO dla rodzin möbelfüße (Model B) — na innych rodzinach z osią Breite
    // (np. besteckeinsatz) regex łapał szerokość jako "wysokość" i przekreślał dostępne pigułki
    var isMoebelfuesse = /mobelfusse|moebelfuesse/.test(location.pathname);
    if (cur && isMoebelfuesse) {
      if (!document.getElementById("fa-variant-greyout-css")) {
        var st = document.createElement("style"); st.id = "fa-variant-greyout-css";
        st.textContent = ".fa-variant-unavailable{opacity:.5;text-decoration:line-through;}";
        document.head.appendChild(st);
      }
      var groups = document.querySelectorAll(".product__variant-group");
      for (var i = 0; i < groups.length; i++) {
        var lab = (groups[i].querySelector(".product__variant-type-label") || {}).textContent || "";
        if (!/Forme|Largeur/i.test(lab)) continue;
        var links = groups[i].querySelectorAll("a[href]");
        for (var j = 0; j < links.length; j++) { var t = hc(links[j].getAttribute("href") || ""); if (t && (t.h !== cur.h || t.c !== cur.c)) links[j].classList.add("fa-variant-unavailable"); }
      }
    }
  } catch (e) {}

  // ---- 2) MODELL jako natywne swatche (identyczne jak Farbe/related_colors) ----
  try {
    var grps = document.querySelectorAll(".product__variant-group");
    for (var k = 0; k < grps.length; k++) {
      var l = (grps[k].querySelector(".product__variant-type-label") || {}).textContent || "";
      if (!/^\s*mod[eè]l/i.test(l)) continue; // DE Modell / IT Modello / FR Modele / EN Model — etykieta pochodzi z locales, wiec literal „Modell" byl martwy poza DE/AT
      var ul = grps[k].querySelector("ul");
      if (!ul) continue;
      if (ul.querySelector("img")) continue; // już natywne swatche (sekcja) — nie ruszaj (inaczej skasowalibyśmy natywny obrazek = miganie)
      ul.classList.remove("product__boxes-variations-list"); // zdejmij styl tekstowy
      ul.classList.add("product__color-variations-list");    // załóż natywny styl swatchy
      if (!document.getElementById("fa-mt-css")) { var c = document.createElement("style"); c.id = "fa-mt-css"; c.textContent = ".fa-mt{display:inline-block;min-width:80px;min-height:80px;}"; document.head.appendChild(c); }
      var as = ul.querySelectorAll("a[href]");
      Array.prototype.forEach.call(as, function (a) {
        if (!a.getAttribute("title")) a.setAttribute("title", (a.textContent || "").trim()); // podpis -> tooltip
        a.textContent = "";          // chowamy tekst OD RAZU (bez błysku tekstu)
        a.classList.add("fa-mt");    // rezerwa rozmiaru kafelka, zanim doładuje się obrazek
        var href = a.getAttribute("href").split("?")[0];
        fetch(href + ".js").then(function (r) { return r.json(); }).then(function (p) {
          var src = p && (p.featured_image || (p.images && p.images[0]));
          if (!src) return;
          if (src.indexOf("//") === 0) src = "https:" + src;
          src += (src.indexOf("?") > -1 ? "&" : "?") + "width=160";
          var im = document.createElement("img"); im.src = src; im.loading = "lazy"; im.width = 80; im.height = 80; im.alt = (p.title || "");
          a.appendChild(im); a.classList.remove("fa-mt");
        }).catch(function () {});
      });
    }
  } catch (e) {}
})();
